import React, { Fragment, useEffect, useState } from 'react';
import { Col, Card, CardHeader, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, } from 'react-redux';
import { updateSettings } from '../../store/settingsSlice';

const SettingsTableModel = ({ props }) => {
  const storeVar = props;
  const dispatch = useDispatch();

  const [submit, setSubmit] = useState(false);
  const [formVar, setFormVar] = useState({
    email: '',
    phoneNumber: '',
    facebook: '',
    instagram: '',
    youtube: '',
    x: '',
    address: '',
    details: '',
    iframe: '',
  });

  useEffect(() => {
    if (storeVar) {
      setFormVar(prevFormVar => ({
        ...prevFormVar,
        email: storeVar?.email ?? "",
        phoneNumber: storeVar?.phoneNumber ?? "",
        facebook: storeVar?.facebook ?? "",
        instagram: storeVar?.instagram ?? "",
        youtube: storeVar?.youtube ?? "",
        x: storeVar?.x ?? "",
        address: storeVar?.address ?? "",
        details: storeVar?.details ?? "",
        iframe: storeVar?.iframe ?? "",
      }));
    }
  }, [storeVar]);


  const submitNewSettings = () => {

    if (emailValid() || phoneNumberValid() || facebookValid() || instaLinkValid() || addressValid() || detailsValid() || youtubeValid() || xValid() || mapValid()) {
      setSubmit(true)
      return null
    }
    setSubmit(false)
    dispatch(updateSettings({ email: formVar.email, phoneNumber: formVar.phoneNumber, facebook: formVar.facebook, instagram: formVar.instagram, youtube: formVar.youtube, x: formVar.x, address: formVar.address, details: formVar.details, iframe: formVar.iframe }))
  }


  const emailValid = () => {
    if (!formVar.email) {
      return "Email is required";
    }
  }
  const phoneNumberValid = () => {
    if (!formVar.phoneNumber) {
      return "Phone Number is required";
    }
  }

  const facebookValid = () => {
    if (!formVar.facebook) {
      return "Facebook link is required";
    }
  }
  const instaLinkValid = () => {
    if (!formVar.instagram) {
      return "Instagram link is required";
    }
  }

  const addressValid = () => {
    if (!formVar.address) {
      return "Address is required";
    }
  }
  const detailsValid = () => {
    if (!formVar.details) {
      return "Youtube Link is required";
    }
  }
  const youtubeValid = () => {
    if (!formVar.youtube) {
      return "Address is required";
    }
  }
  const xValid = () => {
    if (!formVar.x) {
      return "X is required";
    }
  }
  const mapValid = () => {
    if (!formVar.iframe) {
      return "Map Iframe is required";
    }
  }

  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>

              <Col md="6">
                <FormGroup>
                  <Label className="col-form-label" for="recipient-name">Email</Label>
                  <Input className="form-control" type="text" placeholder='Enter Email' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, email: e.target.value }))} value={formVar?.email} />
                  {submit && emailValid() ? <span className='d-block font-danger'>{emailValid()}</span> : ""}
                </FormGroup>
                <FormGroup>
                  <Label className="col-form-label" for="recipient-name">Facebook Link</Label>
                  <Input className="form-control" type="text" placeholder='Enter Facebook Link' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, facebook: e.target.value }))} value={formVar?.facebook} />
                  {submit && facebookValid() ? <span className='d-block font-danger'>{facebookValid()}</span> : ""}
                </FormGroup>
                <FormGroup>
                  <Label className="col-form-label" for="recipient-name">Instagram Link</Label>
                  <Input className="form-control" type="text" placeholder='Enter Instagram Link' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, instagram: e.target.value }))} value={formVar?.instagram} />
                  {submit && instaLinkValid() ? <span className='d-block font-danger'>{instaLinkValid()}</span> : ""}
                </FormGroup>
                <FormGroup>
                  <Label className="col-form-label" for="recipient-name">Address</Label>
                  <Input className="form-control" type="text" placeholder='Enter Address' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, address: e.target.value }))} value={formVar?.address} />
                  {submit && addressValid() ? <span className='d-block font-danger'>{addressValid()}</span> : ""}
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="col-form-label" for="recipient-name">Phone No.</Label>
                  <Input className="form-control" type="text" placeholder='Enter Phone No' onChange={(e) => { if (/^\d{0,10}$/.test(e.target.value)) { setFormVar((prevFormVar) => ({ ...prevFormVar, phoneNumber: e.target.value })) } }} value={formVar?.phoneNumber} minLength={10} maxLength={10} />
                  {submit && phoneNumberValid() ? <span className='d-block font-danger'>{phoneNumberValid()}</span> : ""}
                </FormGroup>
                <FormGroup>
                  <Label className="col-form-label" for="recipient-name">Youtube Link</Label>
                  <Input className="form-control" type="text" placeholder='Enter Youtube Link' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, youtube: e.target.value }))} value={formVar?.youtube} />
                  {submit && youtubeValid() ? <span className='d-block font-danger'>{youtubeValid()}</span> : ""}
                </FormGroup>
                <FormGroup>
                  <Label className="col-form-label" for="recipient-name">X</Label>
                  <Input className="form-control" type="text" placeholder='Enter X Link' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, x: e.target.value }))} value={formVar?.x} />
                  {submit && xValid() ? <span className='d-block font-danger'>{xValid()}</span> : ""}
                </FormGroup>
                <FormGroup>
                  <Label className="col-form-label" for="recipient-name">Description</Label>
                  <Input className="form-control" type="text" placeholder='Enter Description' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, details: e.target.value }))} value={formVar?.details} />
                  {submit && detailsValid() ? <span className='d-block font-danger'>{detailsValid()}</span> : ""}
                </FormGroup>
              </Col>
              <FormGroup>
                <Label className="col-form-label" for="recipient-name">Map</Label>
                <textarea className="form-control" type="text" placeholder='Enter Map IFrame link' rows={4}onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, iframe: e.target.value }))} value={formVar?.iframe} />
                {submit && mapValid() ? <span className='d-block font-danger'>{mapValid()}</span> : ""}
              </FormGroup>

            </Row>


            <ModalFooter style={{ justifyContent: "center" }}>
              <Btn attrBtn={{ color: 'primary', onClick: submitNewSettings }}>Save Changes</Btn>
            </ModalFooter>
          </CardHeader>
        </Card>
      </Col>
    </Fragment>
  );
};

export default SettingsTableModel;
